import { Component, Input, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';
import { Observable, of } from 'rxjs';
import * as fromExpense from '../../store';
import { Store, select } from '@ngrx/store';
import { map } from 'rxjs/operators';
import clone from 'just-clone';

@Component({
    selector: 'ef-expense-pdbo-feature',
    templateUrl: './expense-pdbo-feature.component.html',
    styleUrls: ['./expense-pdbo-feature.component.scss'],
    standalone: false
})
export class ExpensePdboFeatureComponent implements OnInit {
    pdboData$: Observable<any>;
    constructor(
        public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private log: LoggingService,
        private store: Store
    ) {
        this.store.dispatch(
            new fromExpense.LoadExpenseLinePDBO(this.config.data.expenseLineId)
        );
    }

    ngOnInit(): void {
        // const data = [
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-05T00:00:00',
        //         pdbo_type: '1B',
        //         pdbo_typedesc: 'Breakfast',
        //         inuse: true,
        //         pdbo_amount: 9.74,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-05T00:00:00',
        //         pdbo_type: '2L',
        //         pdbo_typedesc: 'Lunch',
        //         inuse: true,
        //         pdbo_amount: 11.06,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-05T00:00:00',
        //         pdbo_type: '3D',
        //         pdbo_typedesc: 'Dinner',
        //         inuse: true,
        //         pdbo_amount: 19.47,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-05T00:00:00',
        //         pdbo_type: '4IE',
        //         pdbo_typedesc: 'Incidental Expenses',
        //         inuse: true,
        //         pdbo_amount: 3.98,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-06T00:00:00',
        //         pdbo_type: '1B',
        //         pdbo_typedesc: 'Breakfast',
        //         inuse: true,
        //         pdbo_amount: 12.98,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-06T00:00:00',
        //         pdbo_type: '2L',
        //         pdbo_typedesc: 'Lunch',
        //         inuse: true,
        //         pdbo_amount: 14.75,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-06T00:00:00',
        //         pdbo_type: '3D',
        //         pdbo_typedesc: 'Dinner',
        //         inuse: true,
        //         pdbo_amount: 25.96,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-06T00:00:00',
        //         pdbo_type: '4IE',
        //         pdbo_typedesc: 'Incidental Expenses',
        //         inuse: true,
        //         pdbo_amount: 5.31,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-07T00:00:00',
        //         pdbo_type: '1B',
        //         pdbo_typedesc: 'Breakfast',
        //         inuse: true,
        //         pdbo_amount: 12.98,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-07T00:00:00',
        //         pdbo_type: '2L',
        //         pdbo_typedesc: 'Lunch',
        //         inuse: true,
        //         pdbo_amount: 14.75,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-07T00:00:00',
        //         pdbo_type: '3D',
        //         pdbo_typedesc: 'Dinner',
        //         inuse: true,
        //         pdbo_amount: 25.96,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-07T00:00:00',
        //         pdbo_type: '4IE',
        //         pdbo_typedesc: 'Incidental Expenses',
        //         inuse: true,
        //         pdbo_amount: 5.31,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-08T00:00:00',
        //         pdbo_type: '1B',
        //         pdbo_typedesc: 'Breakfast',
        //         inuse: true,
        //         pdbo_amount: 12.98,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-08T00:00:00',
        //         pdbo_type: '2L',
        //         pdbo_typedesc: 'Lunch',
        //         inuse: true,
        //         pdbo_amount: 14.75,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-08T00:00:00',
        //         pdbo_type: '3D',
        //         pdbo_typedesc: 'Dinner',
        //         inuse: true,
        //         pdbo_amount: 25.96,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-08T00:00:00',
        //         pdbo_type: '4IE',
        //         pdbo_typedesc: 'Incidental Expenses',
        //         inuse: true,
        //         pdbo_amount: 5.31,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-09T00:00:00',
        //         pdbo_type: '1B',
        //         pdbo_typedesc: 'Breakfast',
        //         inuse: true,
        //         pdbo_amount: 12.98,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-09T00:00:00',
        //         pdbo_type: '2L',
        //         pdbo_typedesc: 'Lunch',
        //         inuse: true,
        //         pdbo_amount: 14.75,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-09T00:00:00',
        //         pdbo_type: '3D',
        //         pdbo_typedesc: 'Dinner',
        //         inuse: true,
        //         pdbo_amount: 25.96,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-09T00:00:00',
        //         pdbo_type: '4IE',
        //         pdbo_typedesc: 'Incidental Expenses',
        //         inuse: true,
        //         pdbo_amount: 5.31,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-10T00:00:00',
        //         pdbo_type: '1B',
        //         pdbo_typedesc: 'Breakfast',
        //         inuse: true,
        //         pdbo_amount: 12.98,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-10T00:00:00',
        //         pdbo_type: '2L',
        //         pdbo_typedesc: 'Lunch',
        //         inuse: true,
        //         pdbo_amount: 14.75,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-10T00:00:00',
        //         pdbo_type: '3D',
        //         pdbo_typedesc: 'Dinner',
        //         inuse: true,
        //         pdbo_amount: 25.96,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-10T00:00:00',
        //         pdbo_type: '4IE',
        //         pdbo_typedesc: 'Incidental Expenses',
        //         inuse: true,
        //         pdbo_amount: 5.31,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-11T00:00:00',
        //         pdbo_type: '1B',
        //         pdbo_typedesc: 'Breakfast',
        //         inuse: true,
        //         pdbo_amount: 9.74,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-11T00:00:00',
        //         pdbo_type: '2L',
        //         pdbo_typedesc: 'Lunch',
        //         inuse: true,
        //         pdbo_amount: 11.06,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-11T00:00:00',
        //         pdbo_type: '3D',
        //         pdbo_typedesc: 'Dinner',
        //         inuse: true,
        //         pdbo_amount: 19.47,
        //         dailyperdiemamount: 59.0
        //     },
        //     {
        //         expenseID: 8295,
        //         pdbo_date: '2024-05-11T00:00:00',
        //         pdbo_type: '4IE',
        //         pdbo_typedesc: 'Incidental Expenses',
        //         inuse: true,
        //         pdbo_amount: 3.98,
        //         dailyperdiemamount: 59.0
        //     }
        // ];
        // this.pdboData$ = of(data);
        this.pdboData$ = this.store.pipe(
            select(fromExpense.getExpenseLinePdbo),
            map(x => clone(x))
        );
    }
    onSave($event: any) {
        this.log.verbose({
            type: 'ExpensePdboFeatureComponent:onSave',
            $event
        });
        this.dialogRef.close($event);
    }
    onCancel() {
        this.log.verbose({
            type: 'ExpensePdboFeatureComponent:onCancel'
        });
        this.dialogRef.close();
    }
}
